package com.narbase.letsgo.common

import com.narbase.letsgo.deployment.Environment

const val IS_DEV_KEY = "IS_DEV"
const val MOBILE_SERVER_URL_KEY = "MOBILE_SERVER_URL"
const val IS_MOBILE_DEV_KEY = "IS_MOBILE_DEV"
const val MOBILE_UPDATES_URL_PATH = "files-updates"
const val MOBILE_UPDATES_FILES_PATH = "public/files-updates"

//TODO: change to Environment.Prod when releasing an app
val mobileEnvironment = Environment.Prod

val SHARE_BASE_URL = "https://share.carapp-africa.net"
fun getBaseUrlOfServer(environment: Environment): String {
    return when (environment) {
        Environment.Dev, Environment.RunningLocalTests -> mobileServerUrl ?: "http://localhost:4567"
        Environment.Staging -> "http://staging.narbase.com:4567"
        Environment.Prod -> "https://car.narbase.com/"
    }
}

private fun getBaseUrlLandingPage(environment: Environment): String {
    return when (environment) {
        Environment.Dev, Environment.RunningLocalTests -> "http://localhost:4567/launch-landing-page"
        Environment.Staging -> "https://car.narbase.com//launch-landing-page"
        Environment.Prod -> "https://car.narbase.com/"
    }
}

internal fun getBaseAppUrl(environment: Environment): String {
    return when (environment) {
        Environment.Dev, Environment.RunningLocalTests -> "http://localhost:8084"
        Environment.Staging -> "https://car.narbase.com/"
        Environment.Prod -> "https://car.narbase.com/"
    }
}


val BASE_URL_OF_SERVER by lazy {
    if (isMobileDev) getBaseUrlOfServer(commonEnvironment)
    else if (isMobile) getBaseUrlOfServer(mobileEnvironment)
    else getBaseUrlOfServer(commonEnvironment)
}

val BASE_URL_LANDING_PAGE by lazy {
    if (isMobileDev) getBaseUrlLandingPage(commonEnvironment)
    else if (isMobile) getBaseUrlLandingPage(mobileEnvironment)
    else getBaseUrlLandingPage(commonEnvironment)
}

val BASE_APP_URL by lazy {
    if (isMobileDev) getBaseAppUrl(commonEnvironment)
    else if (isMobile) getBaseAppUrl(mobileEnvironment)
    else getBaseAppUrl(commonEnvironment)
}
